<app-page>
    <app-title>{{ 'add_multiple_points_of_service' | translate }}</app-title>
    <table appFieldContainer align="center">
        <tr>
            <td>
                {{ 'warning_max_number_of_points_of_service_to_create_at_once' | translate: { max: 30 } }}
                <br>
                <br>
            </td>
        </tr>
        <tr>
            <td>
                <mat-form-field appField>
                    <mat-label>{{ 'friendly_name_prefix' | translate }}</mat-label>
                    <input matInput [formControl]="friendlyNamePrefixField">
                    <mat-error *ngIf="friendlyNamePrefixField.invalid">{{formService.getFieldErrorMessage(friendlyNamePrefixField)}}</mat-error>
                </mat-form-field>
            </td>
        </tr>
        <tr>
            <td>
                <mat-form-field appField>
                    <mat-label>{{ 'friendly_name_suffix_index_from' | translate }}</mat-label>
                    <input matInput [formControl]="friendlyNameSuffixIndexFromField" required>
                    <mat-error *ngIf="friendlyNameSuffixIndexFromField.invalid">{{formService.getFieldErrorMessage(friendlyNameSuffixIndexFromField)}}</mat-error>
                </mat-form-field>
            </td>
        </tr>
        <tr>
            <td>
                <mat-form-field appField>
                    <mat-label>{{ 'friendly_name_suffix_index_to' | translate }}</mat-label>
                    <input matInput [formControl]="friendlyNameSuffixIndexToField" required>
                    <mat-error *ngIf="friendlyNameSuffixIndexToField.invalid">{{formService.getFieldErrorMessage(friendlyNameSuffixIndexToField)}}</mat-error>
                </mat-form-field>
            </td>
        </tr>
        <tr>
            <td>
                <mat-form-field appField>
                    <mat-label>{{ 'type' | translate }}</mat-label>
                    <mat-select [formControl]="typeField">
                        <!-- <mat-option [value]="POINT_OF_SERVICE_TYPE_NONE">{{ 'none' | translate }}</mat-option> -->
                        <mat-option [value]="POINT_OF_SERVICE_TYPE_TABLE">Table</mat-option>
                        <!-- <mat-option [value]="POINT_OF_SERVICE_TYPE_ONLINE">Online</mat-option> -->
                        <!-- <mat-option [value]="POINT_OF_SERVICE_TYPE_ONSITE_PICKUP">Onsite Pickup</mat-option> -->
                        <!-- <mat-option [value]="POINT_OF_SERVICE_TYPE_MENU">Menu</mat-option> -->
                    </mat-select>
                </mat-form-field>
            </td>
        </tr>
        <tr>
            <td align="center">
                <app-action [text]="'submit' | translate"
                    [disabled]="friendlyNamePrefixField.invalid || friendlyNameSuffixIndexFromField.invalid || friendlyNameSuffixIndexToField.invalid || friendlyNameSuffixIndexFromField.value > friendlyNameSuffixIndexToField.value"
                    (onAsyncExecute)="addPointOfService($event)">
                </app-action>
            </td>
        </tr>
    </table>
</app-page>
